<script>
  import LineItem from './LineItem'
  import Mark from './Mark.vue';
  const markTypeClassMap = {
    1: 'danger',
    2: 'warning',
    3: 'primary',
    4: 'relate'
  }
  export default {
    props: {
      editable: Boolean,
      confirmTime: String,
      list: {
        type: Array,
        default: () => [],
      },
    },
    components: { LineItem, Mark },
    data () {
      return {
        markTypeClassMap
      }
    },
    computed: {
      showList () {
        let newList = [...this.list]
        if (this.confirmTime) {
          newList.push({
            lineType: 'time',
            msgDetail: {
              msgDataTime: this.confirmTime
            }
          })
        }
        newList.sort((a,b) => {
          return (+new Date(b.msgDetail.msgDataTime)) - (+new Date(a.msgDetail.msgDataTime))
        })
        return newList
      }
    },
  }
</script>
<template>
  <div class="contentLine">
    <ul class="line" v-if="list && list.length">
      <LineItem
        v-for="(item, index) in showList"
        :key="index"
        :colorClass="markTypeClassMap[item.type]"
        :data="item"
        :type="item.lineType"
      >
        <template #wrapEnd>
          <Mark :editable="editable" :data="item"/>
        </template>
      </LineItem>
    </ul>
    <div v-if="list && !list.length" class="p20">暂无</div>
  </div>
</template>

<style lang="scss">
  @import './style.scss';
</style>